<div class="chat-area">
  <div class="messages" *ngIf="!isEmptyChat"  #chatContainer #messagesContainer (scroll)="checkScrollPosition()">
    <!-- Top infinite scroll: loading older messages spinner -->
    <div *ngIf="isLoadingMoreMsg" class="loading-older-messages">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Loading older messages...</span>
    </div>
    <!-- Top infinite scroll: end of history label -->
    <div *ngIf="!hasMoreMessages && whatsappMessageLog?.length > 0" class="no-more-messages">
      No more messages
    </div>
     <!-- <div class="chat-header"  fxLayout="row" fxLayoutAlign="end center">
      <div class="back-button" (click)="goBack()">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8 8-8z"></path>
        </svg>
      </div>
      <div class="chat-title">
        <div class="avatar">
          <img *ngIf="chats[0].avatar" [src]="chats[0].avatar" alt="avatar" />
          <div *ngIf="!chats[0].avatar" class="avatar-placeholder">
            {{ selectedContact.firstName?.charAt(0) || '?' }}
          </div>
        </div>
        <div class="title-info">
          <h3>
            {{ selectedContact.firstName }}
            <span *ngIf="selectedContact.lastName && selectedContact.lastName.trim()">
              {{ selectedContact.lastName }}
            </span>
            - {{selectedContact.waId}}
          </h3>
          <p>last updated at {{ formatDate(selectedContact.lastMessageTime) }}</p>
          <p *ngIf="canReply && remainingTime" class="reply-time-info">
            Reply window open for {{ remainingTime }}
          </p>


          <p *ngIf="showCannotReplyWarning" class="cannot-reply-warning">
            You can't reply. They need to reply back to start conversation.
          </p>
        </div>
      </div>
      <div class="header-actions" fxLayout="row" fxLayoutAlign="end center">
         <button [attr.guide]="'whatsapp-chat-details-btn-1' + '__' + sanitizedUrl" (click)="toggleSearchPanel()">
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path fill="currentColor"
              d="M15.9 14.3H15l-.3-.3c1-1.1 1.6-2.7 1.6-4.3 0-3.7-3-6.7-6.7-6.7S3 6 3 9.7s3 6.7 6.7 6.7c1.6 0 3.2-.6 4.3-1.6l.3.3v.8l5.1 5.1 1.5-1.5-5-5.2zm-6.2 0c-2.6 0-4.6-2.1-4.6-4.6s2.1-4.6 4.6-4.6 4.6 2.1 4.6 4.6-2 4.6-4.6 4.6z">
            </path>
          </svg>
        </button> 
        <button [attr.guide]="'whatsapp-chat-details-btn-2' + '__' + sanitizedUrl" [matMenuTriggerFor]="chatMenu" >
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path fill="currentColor"
              d="M12 7a2 2 0 1 0-.001-4.001A2 2 0 0 0 12 7zm0 2a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 9zm0 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 15z">
            </path>
          </svg>
        </button>
        <mat-menu #chatMenu="matMenu">
          <button [attr.guide]="'whatsapp-chat-details-btn-3' + '__' + sanitizedUrl" mat-menu-item (click)="sendTemplateMessage()" style="padding-right: 8px; padding-left: 8px;">
            <mat-icon>send</mat-icon>
            <span>Send Template Message</span>
          </button>
          <button [attr.guide]="'whatsapp-chat-details-btn-4' + '__' + sanitizedUrl" mat-menu-item (click)="toggleFavorite()">
            <mat-icon>{{ isFavorite ? 'star' : 'star_border' }}</mat-icon>
            <span>{{ isFavorite ? 'Remove from Favorites' : 'Add to Favorites' }}</span>
          </button>
          <button [attr.guide]="'whatsapp-chat-details-btn-5' + '__' + sanitizedUrl" mat-menu-item (click)="closeChat()">
            <mat-icon>close</mat-icon>
            <span>Close Chat</span>
          </button>
          <button [attr.guide]="'whatsapp-chat-details-btn-6' + '__' + sanitizedUrl" *ngIf="isBlocked == 0" mat-menu-item (click)="blockChat(selectedContact)">
            <mat-icon>block</mat-icon>
            <span>Block</span>
          </button>
          <button [attr.guide]="'whatsapp-chat-details-btn-7' + '__' + sanitizedUrl" *ngIf="isBlocked == 1" mat-menu-item (click)="unblockChat(selectedContact)">
            <mat-icon>block</mat-icon>
            <span>UnBlock</span>
          </button>

          <button [attr.guide]="'whatsapp-chat-details-btn-8' + '__' + sanitizedUrl" mat-menu-item (click)="deleteChat(selectedContact)" class="delete-action">
            <mat-icon>delete_forever</mat-icon>
            <span>Delete Chat</span>
          </button>

          <button [attr.guide]="'whatsapp-chat-details-btn-9' + '__' + sanitizedUrl" mat-menu-item (click)="AssignedUser()">
            <mat-icon>transfer_within_a_station</mat-icon>
            <span>Assigned Users</span>
          </button>
        </mat-menu>
      </div>
    </div> -->
    <div *ngFor="let message of whatsappMessageLog" class="message" [class.sent]="message.isIncomingMessage === 0"
      [class.received]="message.isIncomingMessage === 1" [class.highlighted]="isMessageHighlighted(message.uid)"
      id="message-{{message.uid}}">
      <div [ngClass]="{
  'message-content': true,
  'removedPadding': message.mediaData || message.interactiveType
}">

        <div class="text">

          <ng-container *ngIf="message.message && !message.interactiveType && (!message.mediaData || (message.message !== '[image]' && message.message !== '[document]' && message.message !== '[video]' && message.message !== '[audio]'))">
            <span [innerHTML]="getHighlightedText(message.message)"></span>
          </ng-container>
          <ng-container *ngIf="!message.message && !message.interactiveType">
            <span [innerHTML]="getHighlightedText(message.bodyText)"></span>
          </ng-container>
          <ng-container
            *ngIf="message.message == '' && message.WebHookText && !message.bodyText  && !message.interactiveType">
            <span [innerHTML]="getHighlightedText(message.WebHookText)"></span>
          </ng-container>
          
          <!-- Modern Template Preview -->
          <ng-container *ngIf="message.templatePreviewData">
             <div class="chat-template-preview-wrapper" style="background: #f0f4f8; border-radius: 8px; padding: 5px; margin: 5px 0;">
                <calsoft-template-preview [isNotDialog]="true" [templatePreviewData]="message.templatePreviewData"></calsoft-template-preview>
             </div>
          </ng-container>

          <!-- Fallback manual rendering -->
          <ng-container *ngIf="message.templateComponents && !message.templatePreviewData">
            <!-- Header -->
            <div *ngIf="message.templateComponents.header" class="interactive-header">
              <ng-container *ngIf="message.templateComponents.header.type === 'text'">
                {{ message.templateComponents.header.text }}
              </ng-container>

              <ng-container *ngIf="message.templateComponents.header.type === 'image'">
                <div *ngIf="message.templateComponents.header.url" class="media-grid">
                  <button [attr.guide]="'whatsapp-chat-details-btn-10' + '__' + sanitizedUrl" mat-icon-button class="menu-icon" [matMenuTriggerFor]="imageMenu2" style="margin-left: auto;">
                    <mat-icon>expand_more</mat-icon>
                  </button>

                  <img loading="lazy" [src]="getMediaUrl(message.templateComponents.header.url)"
                    onerror="this.src='assets/images/logo/no-image.png';" alt="Header image">
                  <mat-menu #imageMenu2="matMenu">
                    <button [attr.guide]="'whatsapp-chat-details-btn-11' + '__' + sanitizedUrl" mat-menu-item (click)="openImage(getMediaUrl(message.templateComponents.header.url))">
                      <mat-icon>open_in_new</mat-icon>
                      <span>Open</span>
                    </button>
                    <button [attr.guide]="'whatsapp-chat-details-btn-12' + '__' + sanitizedUrl" mat-menu-item (click)="downloadImage(message.templateComponents.header.url)">
                      <mat-icon>download</mat-icon>
                      <span>Download</span>
                    </button>
                  </mat-menu>

                </div>
                <div *ngIf="!message.templateComponents.header.url && message.templateComponents.header.example"
                  class="media-grid">
                  <button [attr.guide]="'whatsapp-chat-details-btn-13' + '__' + sanitizedUrl" mat-icon-button class="menu-icon" [matMenuTriggerFor]="imageMenu3" style="margin-left: auto;">
                    <mat-icon>expand_more</mat-icon>
                  </button>
                  <img loading="lazy" [src]="message.templateComponents.header.example"
                    onerror="this.src='assets/images/logo/no-image.png';" alt="Header image">
                  <mat-menu #imageMenu3="matMenu">
                    <button [attr.guide]="'whatsapp-chat-details-btn-14' + '__' + sanitizedUrl" mat-menu-item (click)="openImage(getMediaUrl(message.templateComponents.header.example))">
                      <mat-icon>open_in_new</mat-icon>
                      <span>Open</span>
                    </button>
                    <button [attr.guide]="'whatsapp-chat-details-btn-15' + '__' + sanitizedUrl" mat-menu-item (click)="downloadImage(message.templateComponents.header.example)">
                      <mat-icon>download</mat-icon>
                      <span>Download</span>
                    </button>
                  </mat-menu>
                </div>
              </ng-container>
              <ng-container *ngIf="message.templateComponents.header.type === 'location'">
                <div class="chat-location-card">
                  <div class="chat-location-content">
                    <mat-icon class="location-marker">location_on</mat-icon>
                    <div class="location-text">
                      <div class="location-title">{{ message.templateComponents.location?.name || 'Shared Location' }}
                      </div>
                      <div class="location-subtitle">{{ message.templateComponents.location?.address }}</div>
                    </div>
                  </div>
                  <a class="map-link"
                    [href]="'https://www.google.com/maps/search/?api=1&query=' + message.templateComponents.location?.latitude + ',' + message.templateComponents.location?.longitude"
                    target="_blank" rel="noopener">
                    <mat-icon class="map-icon" style="height: auto;">map</mat-icon>
                    <span>View on Map</span>
                  </a>
                </div>
              </ng-container>



              <div *ngIf="message.templateComponents.header.type === 'video'" class="media-video-container">
                <video controls class="media-video">
                  <source [src]="getMediaUrl(message.templateComponents.header.url)" type="video/mp4">
                </video>
              </div>

              <div *ngIf="message.templateComponents.header.type === 'document'" class="media-doc-container">
                <a [attr.guide]="'whatsapp-chat-details-lnk-16' + '__' + sanitizedUrl" (click)="downloadImage(getMediaUrl(message.templateComponents.header.url))" class="doc-link">
                  <div class="doc-icon">
                    <mat-icon>description</mat-icon>
                  </div>
                  <div class="doc-info">
                    <span class="doc-name">View Document</span>
                  </div>
                </a>
              </div>
            </div>

            <!-- Body -->
            <div *ngIf="message.templateComponents.body" class="interactive-body">
              {{ message.templateComponents.body }}
            </div>

            <!-- Buttons -->
            <div *ngIf="message.templateComponents.buttons?.length" class="interactive-buttons">
              <div *ngFor="let button of message.templateComponents.buttons" class="interactive-button">
                <a *ngIf="button.type === 'URL' && button.url" [href]="button.url" target="_blank">
                  {{ button.text }}
                </a>
                <span *ngIf="button.type !== 'URL'">
                  {{ button.text }}
                </span>
              </div>
            </div>

            <!-- Footer -->
            <div *ngIf="message.templateComponents.footer" class="interactive-footer">
              {{ message.templateComponents.footer }}
            </div>
          </ng-container>

          <ng-container *ngIf="message.mediaData">
            <div *ngIf="message.mediaData.type === 'image'  && message.mediaData.url" class="media-grid ">
              <button [attr.guide]="'whatsapp-chat-details-btn-17' + '__' + sanitizedUrl" mat-icon-button class="menu-icon" [matMenuTriggerFor]="imageMenu" style="margin-left: auto;">
                <mat-icon>expand_more</mat-icon>
              </button>
              <img loading="lazy" height="100%" width="330px" [src]="getMediaUrl(message.mediaData.url)"
                onerror="this.src='assets/images/logo/no-image.png';" [alt]="'image'">
              <mat-menu #imageMenu="matMenu">
                <button [attr.guide]="'whatsapp-chat-details-btn-18' + '__' + sanitizedUrl" mat-menu-item (click)="openImage(getMediaUrl(message.mediaData.url))">
                  <mat-icon>open_in_new</mat-icon>
                  <span>Open</span>
                </button>
                <button [attr.guide]="'whatsapp-chat-details-btn-19' + '__' + sanitizedUrl" mat-menu-item (click)="downloadImage(message.mediaData.url)">
                  <mat-icon>download</mat-icon>
                  <span>Download</span>
                </button>
              </mat-menu>
            </div>

            <div *ngIf="message.mediaData.type === 'video'" class="media-video-container">
              <video controls class="media-video">
                <source [src]="getMediaUrl(message.mediaData.url)" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>

            <div *ngIf="message.mediaData.type === 'audio'" class="media-audio-container">
              <audio controls>
                <source [src]="getMediaUrl(message.mediaData.url)" type="audio/ogg">
                Your browser does not support the audio element.
              </audio>
            </div>

            <a [attr.guide]="'whatsapp-chat-details-lnk-20' + '__' + sanitizedUrl" *ngIf="message.mediaData.type === 'document'" (click)="downloadImage(getMediaUrl(message.mediaData.url))"
              class="doc-link">
              <div class="doc-icon">
                <mat-icon>{{ getDocumentIcon(message.mediaData.extension) }}</mat-icon>
              </div>
              <div class="doc-info">
                <span class="doc-name">View Document</span>
                <span class="doc-meta">{{message.mediaData.extension }} &nbsp;&middot;&nbsp; 1.2 MB</span>
              </div>
            </a>

            <div *ngIf="message.mediaData.caption" class="caption">
              {{ message.mediaData.caption }}
            </div>
          </ng-container>
          <ng-container *ngIf="message.interactiveType">
            <!-- Image Preview -->
            <div *ngIf="message?.interactiveData?.headerType === 'image'" class="media-grid bodyGap">
              <button [attr.guide]="'whatsapp-chat-details-btn-21' + '__' + sanitizedUrl" mat-icon-button class="menu-icon" [matMenuTriggerFor]="imageMenu1" style="margin-left: auto;">
                <mat-icon>expand_more</mat-icon>
              </button>
              <img loading="lazy" height="100%" width="330px" [src]="getMediaUrl(message.media.mediaUrl)" alt="image">
              <mat-menu #imageMenu1="matMenu">
                <button [attr.guide]="'whatsapp-chat-details-btn-22' + '__' + sanitizedUrl" mat-menu-item (click)="openImage(message.media.mediaUrl)">
                  <mat-icon>open_in_new</mat-icon>
                  <span>Open</span>
                </button>
                <button [attr.guide]="'whatsapp-chat-details-btn-23' + '__' + sanitizedUrl" mat-menu-item (click)="downloadImage(message.media.mediaUrl)">
                  <mat-icon>download</mat-icon>
                  <span>Download</span>
                </button>
              </mat-menu>
            </div>

            <!-- Video Preview -->
            <div *ngIf="message?.interactiveData?.headerType === 'video'" class="media-video-container bodyGap">
              <video controls class="media-video">
                <source [src]="getMediaUrl(message.media.mediaUrl)" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>

            <!-- Audio Preview -->
            <div *ngIf="message?.interactiveData?.headerType === 'audio'" class="media-audio-container bodyGap">
              <audio controls>
                <source [src]="getMediaUrl(message.media.mediaUrl)" type="audio/ogg">
                Your browser does not support the audio element.
              </audio>
            </div>

            <!-- Document Download -->
            <a *ngIf="message?.interactiveData?.type === 'document'" [href]="getMediaUrl(message.media.mediaUrl)"
              target="_blank" class="doc-link bodyGap">
              <div class="doc-icon">
                <mat-icon>{{ getDocumentIcon(message.media.extension) }}</mat-icon>
              </div>
              <div class="doc-info">
                <span class="doc-name">View Document</span>
                <span class="doc-meta">{{ message.media.extension }} &nbsp;&middot;&nbsp; 1.2 MB</span>
              </div>
            </a>

            <!-- Header -->
            <div *ngIf="message.buttonData?.headerText || message.listData?.headerText || message.ctaData?.headerText"
              class="interactive-header">
              {{ message.buttonData?.headerText || message.listData?.headerText || message.ctaData?.headerText }}
            </div>

            <!-- Body Text -->
            <div *ngIf="message.buttonData?.bodyText || message.listData?.bodyText || message.ctaData?.bodyText"
              class="interactive-body">
              {{ message.buttonData?.bodyText || message.listData?.bodyText || message.ctaData?.bodyText }}
            </div>

            <!-- Buttons -->
            <div *ngIf="message.interactiveType === 'button' && message.buttonData" class="interactive-buttons">
              <div *ngFor="let button of getButtons(message.buttonData.buttons)" class="interactive-button">
                {{ button }}
              </div>
            </div>

            <!-- List -->
            <div *ngIf="message.interactiveType === 'list' && message.listData" class="interactive-list">
              <div class="list-button">{{ message.listData.buttonText }}</div>
              <div class="list-sections">
                <div *ngFor="let section of message.listData.sections" class="list-section">
                  <div class="section-title">{{ section.title }}</div>
                  <div *ngFor="let row of section.rows" class="list-row">
                    <div class="row-title">{{ row.title }}</div>
                    <div *ngIf="row.description" class="row-description">{{ row.description }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- CTA -->
            <div *ngIf="message.interactiveType === 'cta_url' && message.ctaData" class="interactive-cta">
              <a [href]="message.ctaData.url" target="_blank" class="cta-button">
                {{ message.ctaData.displayText }}
              </a>
            </div>

            <!-- Footer -->
            <div *ngIf="message.buttonData?.footerText || message.listData?.footerText || message.ctaData?.footerText"
              class="interactive-footer">
              {{ message.buttonData?.footerText || message.listData?.footerText || message.ctaData?.footerText }}
            </div>
          </ng-container>


          <ng-container
            *ngIf="!message.message && !message.templateComponents && !message.templatePreviewData && !message.WebHookText &&  !message.bodyText  && !message.mediaData">
            <div class="invalid-media">
              <p>Invalid or unsupported media message.</p>
            </div>
          </ng-container>
        </div>

        <div class="time-status">
          <!-- <span class="time">{{ formatMessageTime(message.messagedAt) }}•{{ formatMessageDate(message.messagedAt) }}</span> -->
          <span class="time">{{ formatFullDateTime(message.messagedAt) }}</span>
          <span *ngIf="message.isIncomingMessage === 0" class="status">
            <span *ngIf="message.status === 'read'">✓✓</span>
            <span *ngIf="message.status !== 'read'">✓</span>
          </span>
        </div>



      </div>
    </div>

    <button [attr.guide]="'whatsapp-chat-details-btn-24' + '__' + sanitizedUrl" *ngIf="showScrollButton" class="scroll-to-bottom" (click)="scrollToBottom()"
      [ngStyle]="{ 'margin-bottom.px': inputHeight + 16 }">
      <svg viewBox="0 0 24 24" width="20" height="20">
        <path fill="currentColor" d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
      </svg>
    </button>

  </div>

  <div *ngIf="!isEmptyChat">

    
  <div #inputContainer class="message-input" *ngIf="canReply && NotBlocked">
    <div *ngIf="showCharLimitPopup" class="char-limit-popup">
      Message is too long You should message Below 4000 Character. Try shortening it or send it in multiple parts.

    </div>
    <div class="input-actions">

      <button [attr.guide]="'whatsapp-chat-details-btn-25' + '__' + sanitizedUrl" mat-icon-button [matMenuTriggerFor]="mediaMenu" #trigger="matMenuTrigger" style="width:auto;">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor"
            d="M1.816 15.556v.002c0 1.502.584 2.912 1.646 3.972s2.472 1.647 3.974 1.647a5.58 5.58 0 0 0 3.972-1.645l9.547-9.548c.769-.768 1.147-1.767 1.058-2.817-.079-.968-.548-1.927-1.319-2.698-1.594-1.592-4.068-1.711-5.517-.262l-7.916 7.915c-.881.881-.792 2.25.214 3.261.959.958 2.423 1.053 3.263.215l5.511-5.512c.28-.28.267-.722.053-.936l-.244-.244c-.191-.191-.567-.349-.957.04l-5.506 5.506c-.18.18-.635.127-.976-.214-.098-.097-.576-.613-.213-.973l7.915-7.917c.818-.817 2.267-.699 3.23.262.5.501.802 1.1.849 1.685.051.573-.156 1.111-.589 1.543l-9.547 9.549a3.97 3.97 0 0 1-2.829 1.171 3.975 3.975 0 0 1-2.83-1.173 3.973 3.973 0 0 1-1.172-2.828c0-1.071.415-2.076 1.172-2.83l7.209-7.211c.157-.157.264-.579.028-.814L11.5 4.36a.572.572 0 0 0-.834.018l-7.205 7.207a5.577 5.577 0 0 0-1.645 3.971z">
          </path>
        </svg>
      </button>

      <!-- Media Picker Menu -->
      <mat-menu #mediaMenu="matMenu" [overlapTrigger]="false" class="media-menu">
        <button [attr.guide]="'whatsapp-chat-details-btn-26' + '__' + sanitizedUrl" mat-menu-item (click)="selectMedia('image')">
          <mat-icon>image</mat-icon>
          <span>Photos</span>
        </button>
        <button [attr.guide]="'whatsapp-chat-details-btn-27' + '__' + sanitizedUrl" mat-menu-item (click)="selectMedia('video')">
          <mat-icon>videocam</mat-icon>
          <span>Videos</span>
        </button>
        <button [attr.guide]="'whatsapp-chat-details-btn-28' + '__' + sanitizedUrl" mat-menu-item (click)="selectMedia('audio')">
          <mat-icon>mic</mat-icon>
          <span>Audio</span>
        </button>
        <button [attr.guide]="'whatsapp-chat-details-btn-29' + '__' + sanitizedUrl" mat-menu-item (click)="selectMedia('document')">
          <mat-icon>description</mat-icon>
          <span>Documents</span>
        </button>
      </mat-menu>

      <input [attr.guide]="'whatsapp-chat-details-inp-mediaupload' + '__' + sanitizedUrl" #myInput id="mediaUpload" type="file" ng2FileSelect [uploader]="uploader" multiple hidden />
    </div>
    <div class="input-actions">
      <button [attr.guide]="'whatsapp-chat-details-btn-30' + '__' + sanitizedUrl" [matMenuTriggerFor]="chatMenu" >
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path fill="currentColor"
              d="M12 7a2 2 0 1 0-.001-4.001A2 2 0 0 0 12 7zm0 2a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 9zm0 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 15z">
            </path>
          </svg>
        </button>
        <mat-menu #chatMenu="matMenu">
          <button [attr.guide]="'whatsapp-chat-details-btn-31' + '__' + sanitizedUrl" mat-menu-item (click)="sendTemplateMessage()" style="padding-right: 8px; padding-left: 8px;">
            <mat-icon>send</mat-icon>
            <span>Send Template Message</span>
          </button>
        </mat-menu>
    </div>
    <div class="input-actions"> <button [attr.guide]="'whatsapp-chat-details-btn-32' + '__' + sanitizedUrl" mat-icon-button style="width:auto;" (click)="toggleEmojiPicker($event)">
        <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" class="" fill="none">
          <title>expressions</title>
          <path
            d="M8.49893 10.2521C9.32736 10.2521 9.99893 9.5805 9.99893 8.75208C9.99893 7.92365 9.32736 7.25208 8.49893 7.25208C7.6705 7.25208 6.99893 7.92365 6.99893 8.75208C6.99893 9.5805 7.6705 10.2521 8.49893 10.2521Z"
            fill="currentColor"></path>
          <path
            d="M17.0011 8.75208C17.0011 9.5805 16.3295 10.2521 15.5011 10.2521C14.6726 10.2521 14.0011 9.5805 14.0011 8.75208C14.0011 7.92365 14.6726 7.25208 15.5011 7.25208C16.3295 7.25208 17.0011 7.92365 17.0011 8.75208Z"
            fill="currentColor"></path>
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M16.8221 19.9799C15.5379 21.2537 13.8087 21.9781 12 22H9.27273C5.25611 22 2 18.7439 2 14.7273V9.27273C2 5.25611 5.25611 2 9.27273 2H14.7273C18.7439 2 22 5.25611 22 9.27273V11.8141C22 13.7532 21.2256 15.612 19.8489 16.9776L16.8221 19.9799ZM14.7273 4H9.27273C6.36068 4 4 6.36068 4 9.27273V14.7273C4 17.6393 6.36068 20 9.27273 20H11.3331C11.722 19.8971 12.0081 19.5417 12.0058 19.1204L11.9935 16.8564C11.9933 16.8201 11.9935 16.784 11.9941 16.7479C11.0454 16.7473 10.159 16.514 9.33502 16.0479C8.51002 15.5812 7.84752 14.9479 7.34752 14.1479C7.24752 13.9479 7.25585 13.7479 7.37252 13.5479C7.48919 13.3479 7.66419 13.2479 7.89752 13.2479L13.5939 13.2479C14.4494 12.481 15.5811 12.016 16.8216 12.0208L19.0806 12.0296C19.5817 12.0315 19.9889 11.6259 19.9889 11.1248V9.07648H19.9964C19.8932 6.25535 17.5736 4 14.7273 4ZM14.0057 19.1095C14.0066 19.2605 13.9959 19.4089 13.9744 19.5537C14.5044 19.3124 14.9926 18.9776 15.4136 18.5599L18.4405 15.5576C18.8989 15.1029 19.2653 14.5726 19.5274 13.996C19.3793 14.0187 19.2275 14.0301 19.0729 14.0295L16.8138 14.0208C15.252 14.0147 13.985 15.2837 13.9935 16.8455L14.0057 19.1095Z"
            fill="currentColor"></path>
        </svg>
      </button>

      <emoji-mart *ngIf="showEmojiPicker" (emojiClick)="addEmoji($event)"
        [style]="{ position: 'absolute', bottom: '60px', right: '10px' }">
      </emoji-mart>

    </div>



    <textarea [attr.guide]="'whatsapp-chat-details-sel-33' + '__' + sanitizedUrl" #msgInput placeholder="Type a message" [(ngModel)]="messageText" (keydown.enter)="onKeyUp($event)"
      (input)="adjustTextAreaHeight($event.target)" [disabled]="isSending" rows="1" maxlength="4000"
      style="resize: none; overflow: hidden;height: auto;scrollbar-width: thin;"></textarea>


    <button [attr.guide]="'whatsapp-chat-details-btn-34' + '__' + sanitizedUrl" class="send-button" (click)="sendMessage()"
      [disabled]="!messageText.trim() || isSending">
      <svg viewBox="0 0 24 24" width="24" height="24">
        <path fill="currentColor"
          d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path>
      </svg>
      <span *ngIf="isSending" class="sending-indicator">
        <svg viewBox="0 0 24 24" width="16" height="16" class="spinner">
          <path fill="currentColor"
            d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z">
            <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.75s"
              repeatCount="indefinite" />
          </path>
        </svg>
      </span>
    </button>
  </div>

    
  </div>


  <div *ngIf="!canReply" class="cannot-reply-message">
    <p>You can't reply. They need to reply back to start conversation.</p>
  </div>
  <div *ngIf="!NotBlocked" class="cannot-reply-message">
    <p>You can’t chat with this contact because they’re blocked. Unblock to start a conversation.</p>

  </div>
  <div class="empty-state" *ngIf="isEmptyChat">
    <div class="empty-content">
      <div fxLayout="row" fxLayoutAlign="center center" style="width: 100%;
        display: flex
    ;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    ">
        <svg viewBox="0 0 24 24" width="96" height="96">
          <path fill="#667781"
            d="M19.005 3.175H4.674C3.642 3.175 3 3.789 3 4.821V19.114c0 1.032.642 1.646 1.674 1.646h14.331c1.032 0 1.674-.614 1.674-1.646V4.821c0-1.032-.642-1.646-1.674-1.646zm-4.804 12.646H8.807a.617.617 0 0 1-.616-.616c0-.341.275-.616.616-.616h5.394c.341 0 .616.275.616.616a.617.617 0 0 1-.616.616zm1.933-3.873H8.807a.617.617 0 0 1-.616-.616c0-.341.275-.616.616-.616h7.327c.341 0 .616.275.616.616a.617.617 0 0 1-.616.616zm0-3.874H8.807a.617.617 0 0 1-.616-.616c0-.341.275-.616.616-.616h7.327c.341 0 .616.275.616.616a.617.617 0 0 1-.616.616z">
          </path>
        </svg>
      </div>

      <h3>Start messaging</h3>
      <p>Send messages to this contact</p>
    </div>
  </div>

</div>